import { css } from '@emotion/css';

export const selectedStateStyles = css`
  .ProseMirror p.ProseMirror-selectednode,
  .ProseMirror h1.ProseMirror-selectednode,
  .ProseMirror h2.ProseMirror-selectednode,
  .ProseMirror h3.ProseMirror-selectednode,
  .ProseMirror ol.ProseMirror-selectednode,
  .ProseMirror math-display.ProseMirror-selectednode,
  .ProseMirror .ProseMirror-selectednode.math-node,
  .ProseMirror ul.ProseMirror-selectednode {
    background: #f2f2f2;
    transition: background 200ms ease-in-out;
  }

  .ProseMirror .ProseMirror-selectednode img,
  .ProseMirror .ProseMirror-selectednode .image-web-container,
  .ProseMirror .ProseMirror-selectednode .plyr-container,
  .ProseMirror .ProseMirror-selectednode .webbookmark-container,
  .ProseMirror .ProseMirror-selectednode .callout,
  .ProseMirror .ProseMirror-selectednode.block-menu-selected .flip-card,
  .ProseMirror .ProseMirror-selectednode iframe:not(.selectednode-no-border) {
    box-shadow:
      0 0 0 4px white,
      0 0 0 5px black;
    transition: box-shadow 200ms ease-in-out;
    border-radius: 1.4rem;
  }

  .ProseMirror .ProseMirror-selectednode .selectednode-border {
    box-shadow: 0 0 0 1px black;
    transition:
      box-shadow 200ms ease-in-out,
      border-radius 200ms ease-in-out;
    border-radius: 1.4rem;
    overflow: hidden;
  }

  .ProseMirror .ProseMirror-selectednode .image-web-container img {
    box-shadow: none;
  }
`;
